module.exports = __webpack_public_path__ + "assets/img/driver-btn-463b3f16.png";